import ApplicationController from './application_controller'
import Rails from "@rails/ujs";

export default class extends ApplicationController {

  static targets = [ "hm0_output" ]
  connect () {
    console.log("Règlement facture JS en cours ...");
    super.connect();

  }
}
